import { defaultLocale } from "@pkg/config/languages";
export const dynamicTextDataQuery = `
  "text": select(
    dataType == "statistics" => coalesce(
      *[_type == "statistics" && _id == coalesce(^.text._ref, ^.text)][0].stat[language == $locale][0].value,
      *[_type == "statistics" && _id == coalesce(^.text._ref, ^.text)][0].stat[language == "${defaultLocale}"][0].value,
    ),
    dataType == "people" => *[
      _type == "people" && _id == coalesce(^.text._ref, ^.text)
    ][0].name,
    coalesce(^.text._ref, ^.text, text)
  ),
`

